import axios from 'axios';
import { put } from 'redux-saga/effects';

import { apiEndpoints } from '../../../config/config';
import { Creators } from './actions';

// *************************** Fetch Author Info Saga ***************************
export function* fetchAuthorInfoSaga(action) {
  // console.log('action: ', action);
  try {
    yield put(Creators.fetchAuthorInfoStart());
    const url = yield `${apiEndpoints.authorData}/${action.authorName}`;
    const res = yield axios.get(url);
    let authorData = {};
    // console.log('res: ', res.data.user);
    if (res.data.success === 1) {
      // for (let key in res.data.user) {
      authorData = { ...res.data.user };
      // }
    }
    // console.log('authorData: ', authorData);
    yield put(Creators.fetchAuthorInfoSuccess(authorData));
  } catch (err) {
    yield put(Creators.fetchAuthorInfoFailure(err));
  }
}
// ______________________________________________________________________________

// *************************** Fetch Author Posts Saga ***************************
export function* fetchAuthorPostsSaga(action) {
  try {
    yield put(Creators.fetchAuthorPostsStart());
    let url;
    if (action.pageNumber === 1) {
      url = yield `${apiEndpoints.authorPosts}/${action.authorName}/10`;
    } else {
      url = yield `${apiEndpoints.authorPosts}/${action.authorName}/10/page/${
        action.pageNumber
      }`;
    }
    // console.log('url: ', url);
    const res = yield axios.get(url);
    // console.log('res: ', res);
    const authorPosts = [];
    if (res.data.success === 1) {
      for (let key in res.data.datasets) {
        authorPosts.push({
          id: key,
          ...res.data.datasets[key]
        });
      }
    }
    // console.log('authorPosts: ', authorPosts);
    yield put(Creators.fetchAuthorPostsSuccess(authorPosts));
  } catch (err) {
    yield put(Creators.fetchAuthorPostsFailure(err));
  }
}
// ______________________________________________________________________________

// *************************** Increase Post Count Saga ***************************
// export function* increasePostCountSaga(action) {
//   try {
//     const url = yield `${apiEndpoints.increasePostCount}/${action.postId}`;
//     const res = yield axios.post(url);
//     // console.log('res: ', res);
//     if (res.data.success === 1) {
//       return;
//     }
//   } catch (err) {
//     console.log('Error came while increasing post count');
//     return;
//   }
// }
// ______________________________________________________________________________
